const initialstate = {
    data:[],
    viewdata:[],
    docdata:[],
}

const AdOrgDocument =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'FETCH_VIEW_DATA_SUCCESS':
                return {... state, viewdata:action.payload};
                case 'VIEW_DATA_SUCCESS':
                return {... state, docdata:action.payload};
            default :
            return state;
    }
};
export default AdOrgDocument;